import React, { useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './components.css';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { Link, useNavigate } from 'react-router-dom';	
import CartContext from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const CustomNavbar = () => {
	const navigate = useNavigate();
	const { totalItems } = useContext(CartContext);
	const { user } = useAuth();

	return (
		<Navbar bg="danger" variant="dark" expand="lg" sticky="top">
			<Container>
				<Navbar.Brand as={Link} to="/" className="fw-bold fs-2">Noureesh Foods</Navbar.Brand>
				<Navbar.Toggle aria-controls="basic-navbar-nav" />
				<Navbar.Collapse id="basic-navbar-nav">
					<Nav className="ms-auto text-center">
						<Nav.Link as={Link} to="/" className="text-white nav-link-custom">Home</Nav.Link>
						<Nav.Link as={Link} to="/menu" className="text-white nav-link-custom">Menu</Nav.Link>
						<Nav.Link as={Link} to="/about" className="text-white nav-link-custom">About</Nav.Link>
						<Nav.Link as={Link} to="/contact" className="text-white nav-link-custom">Contact</Nav.Link>
						{user && (
							<Nav.Link as={Link} to="/dashboard" className="text-white nav-link-custom">
								Dashboard
							</Nav.Link>
						)}
						{!user && (
							<Nav.Link as={Link} to="/login" className="text-white nav-link-custom">
								Login or Sign Up
							</Nav.Link>
						)}
						<Button variant="light" className="ms-2" onClick={() => navigate('/cart')}>
							<FontAwesomeIcon icon={faShoppingCart} /> Cart
							{totalItems > 0 && (
								<span className="ms-2 badge bg-danger rounded-pill">
									{totalItems}
								</span>
							)}
						</Button>
					</Nav>
				</Navbar.Collapse>
			</Container>
		</Navbar>
	)
};

export default CustomNavbar;
